import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArticleEntryHeader } from "../layouts/article";
import { Reveal } from "../components/ui/reveal";
import { MediaSlotView } from "../render/context";
import { resolveSlotMedia } from "../render/slot-media";
/** Where this block's way back leads. The block's own decision, not a layout's. */
const NEWS_PATH = "/news";
/**
 * ArticleHeaderBlock — the masthead of a news article.
 *
 * Opens a press release hosted on diality.com: headline, a category · date meta
 * line, and the summary as a lede.
 */
/**
 * Prototype-aligned article masthead, also reused by the full news template.
 *
 * A THIN WRAPPER since the article layout preset landed: the markup lives in
 * layouts/article.tsx so a page drawn by the Article template and a page
 * carrying an ArticleHeader block cannot drift apart. What stays here is this
 * block's own decision — that its way back leads to the site's news page.
 */
export function ArticleHeaderView({ data }) {
    return _jsx(ArticleEntryHeader, { data: data, backHref: NEWS_PATH });
}
export function ArticleHeaderBlock({ data }) {
    return (_jsxs("div", { className: "@container w-full", children: [_jsx(ArticleHeaderView, { data: data }), data.image ? (_jsx(Reveal, { className: "relative z-[2] mx-auto mt-[-100px] w-[86.666cqw] @min-[701px]:mt-[-126px] @min-[701px]:w-[calc(100%_-_50px)] @min-[901px]:mt-[-170px] @min-[901px]:max-w-[1132px]", children: _jsx("figure", { className: "m-0 aspect-[4/3] w-full overflow-hidden rounded-xl bg-secondary @min-[701px]:aspect-video @min-[901px]:aspect-[1132/590] @min-[901px]:rounded-lg", children: _jsx(MediaSlotView, { image: data.image, className: "h-full w-full rounded-none object-cover" }) }) })) : null] }));
}
export function articleHeaderFromBlock(block, resolve) {
    const s = block.scalars ?? {};
    return {
        heading: s.heading || "",
        date: s.date || undefined,
        category: s.category || undefined,
        topic: s.topic || undefined,
        location: s.location || undefined,
        source: s.source || undefined,
        sourceUrl: s.sourceUrl || undefined,
        summary: s.summary || undefined,
        image: resolveSlotMedia(block, "image", resolve),
    };
}
export const articleHeaderBlockEntry = {
    Component: ArticleHeaderBlock,
    fromBlock: articleHeaderFromBlock,
};
//# sourceMappingURL=article-header.js.map